import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AdminRoute = ({ children }) => {
  const { user, isAuthenticated } = useAuth();

  console.log('🛡️ AdminRoute - isAuthenticated:', isAuthenticated);
  console.log('🛡️ AdminRoute - user:', user);
  console.log('🛡️ AdminRoute - user.role:', user?.role);

  if (!isAuthenticated) {
    console.log('❌ AdminRoute - Not authenticated, redirecting to /login');
    return <Navigate to="/login/" replace />;
  }

  if (!user || user.role !== 'admin') {
    console.log('❌ AdminRoute - Not admin or no user, redirecting to /dashboard');
    console.log('   User exists:', !!user);
    console.log('   User role:', user?.role);
    return <Navigate to="/dashboard" replace />;
  }

  console.log('✅ AdminRoute - Access granted');
  return children;
};

export default AdminRoute;

